module.exports = "<div class=\"swagger-ui\" id=\"swagger-ui\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/api-doc/api-doc.component.html
// module id = ./src/app/api-doc/api-doc.component.html
// module chunks = main